<template>
  <div>
    <base-header type="gradient-primary" class="pb-10 pb-8 pt-5 pt-md-8">
      <!-- Card stats -->
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div class="card shadow">
            <datatable-header title="Potentialee Lists">
              <div slot="header-right">
                <div
                  class="form-control form-control-sm dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >Selected List: {{selectedListId != null ? potentialeeLists.find(l => l.id === selectedListId).name : "None"}}</div>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <a
                    v-for="potentialeeList in potentialeeLists"
                    :key="potentialeeList.id"
                    class="dropdown-item"
                    @click="selectedListId = potentialeeList.id"
                  >
                    {{potentialeeList.name}}
                    <div class="text-gray">{{potentialeeList.type}}</div>
                  </a>
                </div>
              </div>
            </datatable-header>
            <potentialees-table :potentialees="potentialees" />
          </div>
        </div>
      </div>
    </div>

    <modal id="viewPotentialeeStats" title="View Potentialee Stats">
      <potentialee-stats :potentialee="viewingPotentialee.stats" />
    </modal>
    <modal id="viewPotentialeeLists" title="Potentialee Lists">
      <potentialee-lists :potentialee="viewingPotentialee" />
    </modal>
    <modal id="contactPotentialee" title="Contact">
      <potentialee-contact />
    </modal>
    <modal id="viewPotentialee" title="View Potentialee">
      <edit-potentialee-form :potentialee="viewingPotentialee" readonly />
    </modal>
    <modal id="editPotentialee" title="Edit Potentialee">
      <edit-potentialee-form :potentialee="editingPotentialee" />
    </modal>
  </div>
</template>

<script>
window.$ = window.jQuery = require("jquery");

import firebase from "@/config/firebase.js";

import DataTableHeader from "@/components/DataTable/DataTableHeader.vue";
import PotentialeesTable from "@/views/potentialees/components/PotentialeesTable.vue";

import EditPotentialeeForm from "@/views/potentialees/components/EditPotentialeeForm.vue";
import PotentialeeStats from "@/views/potentialees/components/PotentialeeStats.vue";
import PotentialeeLists from "@/views/potentialees/components/PotentialeeLists.vue";
import PotentialeeContact from "@/views/potentialees/components/PotentialeeContact.vue";

import Modal from "@/components/Modal.vue";

export default {
  components: {
    "datatable-header": DataTableHeader,
    "potentialees-table": PotentialeesTable,
    "edit-potentialee-form": EditPotentialeeForm,
    "potentialee-stats": PotentialeeStats,
    "potentialee-lists": PotentialeeLists,
    "potentialee-contact": PotentialeeContact,
    modal: Modal
  },
  data() {
    return {
      potentialees: [],
      selectedListId: null,
      potentialeeLists: [],
      editingPotentialee: {},
      viewingPotentialee: {}
    };
  },
  computed: {
    curOrg() {
      return this.$store.state.usermain.curOrg;
    }
  },
  watch: {
    curOrg() {
      this.getPotentialeeLists();
    },
    selectedListId() {
      this.getPotentialees();
    }
  },
  methods: {
    async getPotentialees() {
      console.log("GETTING POTENTIALEES");
      
      await this.getPotentialeeLists();

      const orgId = this.$store.state.usermain.curOrg.id;

      const currentPotentialeesList = this.potentialeeLists.find(l => l.id === this.selectedListId);
      
      const potentialeeRefs = currentPotentialeesList.potentialeeIds.map(pId => {
        return firebase
          .firestore()
          .doc(`potentialees/${pId}`)
          .get();
      });

      await Promise.all(potentialeeRefs)
        .then(this.handleNewPotentialeesData)
        .catch(e => console.log(e));
    },
    handleNewPotentialeesData(docs) {
      const documents = docs.map(doc => {
        const docData = doc.data();
        docData.id = doc.id;

        return docData;
      });

      this.potentialees = documents;
    },
    async getPotentialeeLists(){
      const orgId = this.$store.state.usermain.curOrg.id;
      const userId = firebase.auth().currentUser.uid;

      const personalListsPromise = firebase
        .firestore()
        .collection(`organizations/${orgId}/users/${userId}/potentialeeLists`)
        .get()
        .then(querySnapshot => {
          const documents = querySnapshot.docs.map(doc => {
            const docData = doc.data();
            docData.id = doc.id;
            docData.type = "Personal";

            return docData;
          });

          return documents;
        });

      const orgListsPromise = firebase
        .firestore()
        .collection(`organizations/${orgId}/potentialeeLists`)
        .get()
        .then(querySnapshot => {
          const documents = querySnapshot.docs.map(doc => {
            const docData = doc.data();
            docData.id = doc.id;
            docData.type = "Organization";

            return docData;
          });

          return documents;
        });

      await Promise.all([personalListsPromise, orgListsPromise]).then(values => {
        this.potentialeeLists = values[0].concat(values[1]);
      });
    }
  },
  mounted() {
    this.getPotentialeeLists();

    $("#viewPotentialeeLists").on("hidden.bs.modal", () =>
      this.getPotentialees()
    );
  }
};
</script>
<style></style>
